function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Ink from 'react-ink';
import PropTypes from 'prop-types';
import { ChoicePadContainer, ChoiceIcon, ChoiceText, ChoiceInputPositioner } from './ChoicePad.styles';
import { RadioInput } from '../Radio/Radio';
export var ChoicePadRadio = function ChoicePadRadio(props) {
  var checked = props.checked,
      disabled = props.disabled,
      icon = props.icon,
      iconWidth = props.iconWidth,
      iconHeight = props.iconHeight,
      label = props.label,
      hideLabel = props.hideLabel,
      hideInput = props.hideInput,
      borderColor = props.borderColor,
      checkedColor = props.checkedColor,
      inputPosition = props.inputPosition;
  var labelIsJSX = /*#__PURE__*/React.isValidElement(label);
  return /*#__PURE__*/React.createElement(ChoicePadContainer, {
    checked: checked,
    disabled: disabled,
    borderColor: borderColor,
    checkedColor: checkedColor,
    inputPosition: inputPosition
  }, !disabled && /*#__PURE__*/React.createElement(Ink, {
    duration: 300,
    style: {
      zIndex: 1
    },
    opacity: 0.1
  }), /*#__PURE__*/React.createElement(ChoiceInputPositioner, {
    inputPosition: inputPosition,
    hidden: hideInput
  }, /*#__PURE__*/React.createElement(RadioInput, _extends({}, props, {
    inverted: checked
  }))), icon && /*#__PURE__*/React.createElement(ChoiceIcon, {
    disabled: disabled,
    backgroundUrl: icon,
    width: iconWidth,
    height: iconHeight,
    role: "img",
    "aria-label": "image",
    mb: hideLabel ? 0 : 'xxs'
  }), labelIsJSX ? label : /*#__PURE__*/React.createElement(ChoiceText, {
    inputPosition: inputPosition,
    disabled: disabled,
    checked: checked,
    srOnly: hideLabel
  }, label));
};
ChoicePadRadio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Visually hide the label */
  hideLabel: PropTypes.bool,

  /** Visually hide radio input on the upper-right corner */
  hideInput: PropTypes.bool,

  /** Path to image */
  icon: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  borderColor: PropTypes.string,
  checkedColor: PropTypes.string,
  inputPosition: PropTypes.string
};
ChoicePadRadio.defaultProps = {
  m: 0,
  flexGrow: 1,
  alignItems: 'initial',
  iconHeight: '2.75em',
  iconWidth: '2.75em',
  hideInput: false
};
export default ChoicePadRadio;